import React from 'react';
import {
    extractWindowsFolderPaths,
    openLocalFolderPath
} from '@gUtils/local_folder_path';
import './folder_path_text.less';

/**
 * 将文本中的 Windows 文件夹路径渲染为可点击链接。
 * @param {{ text: string|number|null|undefined, className?: string }} props
 */
const FolderPathText = ({ text, className = '' }) => {
    if (text === undefined || text === null || text === '') {
        return null;
    }
    const str = String(text);
    const paths = extractWindowsFolderPaths(str);
    if (!paths.length) {
        return <span className={className}>{str}</span>;
    }

    const nodes = [];
    let cursor = 0;
    paths.forEach((item, index) => {
        if (item.start > cursor) {
            nodes.push(
                <span key={`t-${index}`}>{str.slice(cursor, item.start)}</span>
            );
        }
        nodes.push(
            <a
                key={`p-${index}`}
                className="amp-folder-path-link"
                href={item.path}
                title={`打开文件夹：${item.path}`}
                onClick={(e) => openLocalFolderPath(item.path, e)}
            >
                {item.raw}
            </a>
        );
        cursor = item.end;
    });
    if (cursor < str.length) {
        nodes.push(<span key="t-tail">{str.slice(cursor)}</span>);
    }

    return <span className={className}>{nodes}</span>;
};

export default FolderPathText;
